import React, { Fragment, useEffect, useState, useContext } from "react";
import { Card, Col, Row} from "react-bootstrap";
import { AuthContext } from "./../../../Auth/AuthProvider";
import { abpnClient } from "./../../../../Services/AbpnClient";
import AbpnSpinner from "../../../Shared/Components/AbpnSpinner";
import { AbccAssessmentCard } from "./AbccAssessmentCard";
import { ExamAssessmentCard } from "./ExamAssessmentCard";
import { NonAbpnAssessmentCard } from "./NonAbpnAssessmentCard";
import { AssessmentsResult, ExamAssessment, NonAbpnAssessment } from "../Models/CCAssessment";
import { CCBlock } from "../../../Physician/Models/CCBlock";

interface IProps{
    ccBlock: CCBlock;
}

export function CCAssessments(props: IProps) {

    const [assessments, setAssessments] = useState<AssessmentsResult>(null);
    const authContext = useContext(AuthContext);

    useEffect(()=>{
        abpnClient.get<AssessmentsResult>(`/api/physician/GetCCAssessments?ccBlockId=${props.ccBlock.ccBlockId}`,authContext)
        .then(_=>{setAssessments(_);
        });
    },[]);

    if (assessments == null) return <AbpnSpinner></AbpnSpinner>

    return (
        <Card className="mb-4" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="mb-0 font-weight-bolder">
                    <span className="text-pp-primary">Assessments</span>
                </Card.Title>

                <Row className="mt-3">
                    <Col xs={12} md={12} lg={12} xl={12}>
                        <Fragment>
                            {assessments != null ?
                                <Fragment>
                                    {assessments?.examAssessments?.length > 0 ?
                                        assessments.examAssessments.map((examAssessment: ExamAssessment)=> <ExamAssessmentCard key={examAssessment.certificationId} examAssessment={examAssessment} />) : null}
                                    {assessments?.nonAbpnAssessments?.length > 0 ?
                                    assessments.nonAbpnAssessments.map((nonAbpnAssessment: NonAbpnAssessment) => <NonAbpnAssessmentCard key={nonAbpnAssessment.certificationId} nonAbpnAssessment={nonAbpnAssessment} />) : null}
                                </Fragment>
                                :
                                <Card.Text bsPrefix="ml-2">No Certificates</Card.Text>}
                        </Fragment>
                    </Col>
                </Row>

           </Card.Body>
        </Card>
    );
}
